import { PaymentStatus } from "../../../../core/schema/PaymentStatus.js";

export const paymentStatusTextColorMap: Record<PaymentStatus, string> = {
	[PaymentStatus.Unpaid]: "text-primary",
	[PaymentStatus.PaidPartially]: "text-themeBlue",
	[PaymentStatus.Paid]: "text-tertiary",
	[PaymentStatus.Refunded]: "text-themeBlue",
	[PaymentStatus.AwaitingRefund]: "text-themeBlue",
};
